import React from 'react'
import { MessageDescriptor, useIntl } from 'react-intl'
import { View } from 'react-native'

import styled from 'styled-components/native'

import { getFormattedMessageSafe } from '@lyrahealth-inc/shared-app-logic/src/features/intl/utils/getFormattedMessageSafe'

import { BodyText } from '../../atoms/bodyText/BodyText'
import { IS_WEB } from '../../constants'
import { useMediaQuerySize } from '../../hooks/useMediaQuerySize'
import { BodyTextSize } from '../../styles/typeStyles'
import { ThemeType } from '../../utils/themes/ThemeProvider'

const ValuePropsListContainer = styled.View<{ theme: ThemeType; isCondensedVersion?: boolean }>(
  ({ theme: { spacing, breakpoints }, isCondensedVersion }) => ({
    flexDirection: isCondensedVersion || breakpoints.isMinWidthLaptop ? 'column' : 'row',
    alignItems: isCondensedVersion || breakpoints.isMinWidthLaptop ? 'flex-start' : 'center',
    gap: isCondensedVersion ? spacing['8px'] : spacing['32px'],
    flexWrap: 'wrap',
    ...(isCondensedVersion && { margin: 'auto', marginBottom: spacing['32px'] }),
  }),
)

const ValuePropsItem = styled.View<{ theme: ThemeType; isCondensedVersion?: boolean }>(
  ({ theme: { spacing, breakpoints }, isCondensedVersion }) => ({
    flexDirection: 'row',
    gap: spacing['12px'],
    alignItems: 'center',
    flexBasis: 'fit-content',
    ...(breakpoints.isMinWidthLaptop &&
      !isCondensedVersion && {
        flexGrow: 1,
        width: '100%',
      }),
    ...(isCondensedVersion && {
      width: 'fit-content',
    }),
  }),
)

const ValuePropsItemTextContainer = styled.View({
  flexShrink: 1,
  ...(IS_WEB && {
    flexWrap: 'wrap',
  }),
})

const ValuePropsItemIcon = styled.View<{ theme: ThemeType }>(({ theme: { spacing } }) => ({
  height: spacing['56px'],
  width: spacing['56px'],
}))

export type ValuePropsItemType = {
  icon: React.ReactNode
  title: string | MessageDescriptor
  values?: Record<string, string | number | boolean>
}

export type ValuePropsIconListProps = {
  items: ValuePropsItemType[]
  isCondensedVersion?: boolean
}

export const ValuePropsIconList: React.FC<ValuePropsIconListProps> = ({ items, isCondensedVersion }) => {
  const { formatMessage } = useIntl()
  const { isMobileSized } = useMediaQuerySize()

  return (
    <ValuePropsListContainer isCondensedVersion={isCondensedVersion}>
      {items.map(({ title, values, icon }, index) => (
        <ValuePropsItem key={index} isCondensedVersion={isCondensedVersion}>
          {isCondensedVersion ? <View>{icon}</View> : <ValuePropsItemIcon>{icon}</ValuePropsItemIcon>}
          <ValuePropsItemTextContainer>
            <BodyText
              size={isMobileSized ? BodyTextSize.DEFAULT : BodyTextSize.LARGE}
              text={getFormattedMessageSafe(title, formatMessage, values)}
            />
          </ValuePropsItemTextContainer>
        </ValuePropsItem>
      ))}
    </ValuePropsListContainer>
  )
}
